import axios from 'axios'
import ApiRotas from '@/modules/services/rotas.api'
import ServiceHandler from '@/modules/services/handler/service.handler'
import MensagensHelper, { MSG_ALERTA } from '@/utils/mensagens.helper'

import * as msg from '../mensagens/faturamento.msg'

class FaturamentoService {
  constructor() {
    this.rota = 'faturamentos'
  }

  async retornaFaturamentos(filtroPeriodo) {
    try {
      const params = { params: filtroPeriodo }

      const retorno = await axios.get(`${ApiRotas}/${this.rota}`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, msg.NAO_HA_FATURAMENTOS)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async retornaFaturamentos30(filtroPeriodo) {
    try {
      const params = { params: filtroPeriodo }

      const retorno = await axios.get(`${ApiRotas}/${this.rota}/30dias`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, msg.NAO_HA_FATURAMENTOS)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async retornaFaturamentos7dias(filtroPeriodo) {
    try {
      const params = { params: filtroPeriodo }

      const retorno = await axios.get(`${ApiRotas}/${this.rota}/7dias`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, msg.NAO_HA_FATURAMENTOS)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async retornaFaturamentosHoje(filtroPeriodo) {
    try {
      const params = { params: filtroPeriodo }

      const retorno = await axios.get(`${ApiRotas}/${this.rota}/hoje`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, msg.NAO_HA_FATURAMENTOS)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }
}

export default new FaturamentoService()
